// extracted by mini-css-extract-plugin
var _1 = "account-details-form__g0pGo";
export { _1 as "accountDetailsForm" }
